import { ChangeDetectorRef, Component,Input, ViewChild } from '@angular/core';
import { WidgetBuilderVarService } from '../widget-builder-service/widget-builder-var.service';
import { Subject } from 'rxjs';
import { ErrorMsgHandler } from 'src/app/shared/errormanagement/handleerror';
import { SharedService } from 'src/app/services/shared.service';
import { DashboardBuilderService } from '../dashboard-builder-service/dashboard-builder.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogBoxComponent } from 'src/app/shared/dialog-box/dialog-box.component';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DashboardBuilderVarService } from '../dashboard-builder-service/dashboard-builder-var.service';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { takeUntil } from 'rxjs/operators';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import jsPDF from 'jspdf';
import { Metropolis_ExtraLight, Metropolis_Light,Metropolis_LightItalic,Metropolis_Medium,Metropolis_Regular,Metropolis_SemiBold} from 'src/assets/fonts/font';
import { UserOptions } from 'jspdf-autotable';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

@Component({
  selector: 'app-chart-table',
  templateUrl: './chart-table.component.html',
  styleUrls: ['./chart-table.component.scss']
})
export class ChartTableComponent {

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  public viewPort: CdkVirtualScrollViewport;

public rows: {col1: number, col2: string}[] = [];

public get inverseOfTranslation(): string {
  if (!this.viewPort || !this.viewPort["_renderedContentOffset"]) {
    return "-0px";
  }
  let offset = this.viewPort["_renderedContentOffset"];
  return `-${offset}px`;
}

  private _data:any = {};
  @Input() mode:string;
  @Input() widgetId:string;
  @Input() widgetInfo:any = {};
  @Input() preview_subtitle:string = "";
  @Input()
  set data(value:any){
    if(value !== this._data) {
      this._data = value
      if(this._data){
      if(Object.keys(this._data).length){
// console.log("input data changed ==",this._data)
        this.setWidgetData()
        if(!this.handledashboardwidgetnodata.status && !this.errorhandledashboardwidget.status){
          this.setStyle()
        }
        this.isProgress = false
      }
    }
  }
  }
 
  get data():any{
    return this._data;
  }

  private destroy$: Subject<void> = new Subject<void>();
  isProgress:boolean = true;
  chart_type:string = "";
  title:string = "";
  subtitle:string = ""
  tableData:any = {};

  handledashboardwidgetnodata = new ErrorMsgHandler()
  errorhandledashboardwidget = new ErrorMsgHandler()

  overlayRef: cdkOverlayRef;
  dialogRef: any;
  previewRef:any;
  filterDays :any

  maxdate = this.timeZoneService.getcurrentuserTime().format(this.dashboardService.timeformat)
  mindate = this.timeZoneService.toUserTimeZone(this.sharedService.timeRange.event_time_range[0]).format('YYYY-MM-DD HH:mm:ss');
   
  defaultTimeRange = {
    from: this.timeZoneService.getcurrentuserTime().clone().startOf('D').format('YYYY-MM-DD'),
    to: this.timeZoneService.getcurrentuserTime().format('YYYY-MM-DD')
  }


  timeRange = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });

  selectTime = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });

  constructor(
    public widgetbuildervarservice: WidgetBuilderVarService,
    private cdkOverlyayService: CdkOverlyayService,
     private sharedService:SharedService,
     private dashboardBuilderService:DashboardBuilderService,
     public dashboardBuilderVarService:DashboardBuilderVarService,
     public matDialog: MatDialog,
     private timeZoneService:TimeZoneService,
     private dashboardService:DashboardService,
     private fb: UntypedFormBuilder,
     private cdf: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if(this.mode === "preview"){
      this.isProgress = false
    }
     if(Object.keys(this._data).length){
      this.setWidgetData()
    }
    if(this.mode === "builder"){

      this.filterDays = this.widgetInfo?.time_range[2]
      this.setTimeRange(this.widgetInfo?.time_range)
      this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
    }
    this.widgetbuildervarservice.previewProgress$.pipe(takeUntil(this.destroy$))
    .subscribe((val)=>{

      if(val){
        this.isProgress = true
      }else{
        this.isProgress =false
      }
    })
    
  }

  readonly MAX_VISIBLE_ROWS = 10;

    /** Whether scroll should be enabled (more rows than the visible limit) */
    get hasOverflowRows(): boolean {
      // return (this.tableData?.rows?.length ?? 0) > this.MAX_VISIBLE_ROWS;
      return this.tableData?.rows
    }
  
    /** TrackBy strategy for *ngFor on table rows */
    trackByRow(index: number, row): string {
      return `${row.time}-${row.src_ip}-${index}`;
    }
  
    /** TrackBy strategy for table headers */
    trackByHeader(index: number, header): string {
      return header.value;
    }

    get displayRows() {
      if (!this.tableData?.rows?.length) return [];
      // return this.tableData.rows.slice(0, this.MAX_VISIBLE_ROWS);
      return this.tableData.rows
    }

    setWidgetData(){
      this.errorhandledashboardwidget.resetError()
      this.handledashboardwidgetnodata.resetError()
      if(this.mode == "builder") {
//console.log("mode builder",this._data)
        if(this._data.hasOwnProperty("error")){
          this.errorhandledashboardwidget.seterror(true, this._data.error?.errmsg);        
        } 
        else {
          if(this.preview_subtitle){
            this.subtitle = this.preview_subtitle
          }
          this.chart_type = this._data["type"]
          this.title = this._data["title"]
//console.log(this.title,"=============title")
            if(!this._data["widgetdata"]?.rows?.length){
            this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
          } else {
            this.tableData = this._data["widgetdata"] 
            this.tableData = this.formatWidgetData(this.tableData)
          } 
        }
        
        this.cdf.detectChanges()
      } else if(this.mode == "preview"){
//console.log("mode builder",this._data)
        
        if(this._data.hasOwnProperty("error")){
          this.errorhandledashboardwidget.seterror(true, this._data.error?.errmsg);        
        } 
        else {
          this.chart_type = this._data["type"]
          this.title = this._data["title"]
//console.log(this.title,"=============title")
          this.subtitle = this._data["subtitle"]
          if(!this._data["widgetdata"]?.rows?.length){
            this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
          } else {
            this.tableData = this._data["widgetdata"] 
            this.tableData = this.formatWidgetData(this.tableData)
          } 
        }
      }

//console.log("TableData =---->",this.tableData)
    }

  
    setStyle(){
      let th = this._data.style.table_header
      let td = this._data.style.table_body
      let enable = th?.enable ? '' : ''
      let thFont =th?.["font-size"] ? this._data.style?.table_header["font-size"] : '12'
      let thAlign = th?. ["text-align"] ? this._data.style?.table_header["text-align"] : 'left'
      let thbg = th?. ["background-color"] ? this._data.style?.table_header["background-color"] : '#f1f6f8'

      let tdFont = td?.["font-size"] ? this._data.style?.table_body["font-size"] : '12'
      // let tdbg = td?. ["background-color"] ? this._data.style?.table_body["background-color"] : '#ffffff'
      // this.widgetbuildervarservice.tableStyle.th = '\"{font-size : '+"\'"+font + 'px\'}\"'

    this.widgetbuildervarservice.tableStyle.th ={'display':enable,'font-size': thFont + "px",'text-align': thAlign ,'background-color': thbg}
    // this.widgetbuildervarservice.tableStyle.td ={'font-size': tdFont + "px",'background-color': tdbg}
    this.widgetbuildervarservice.tableStyle.td ={'font-size': tdFont + "px"}
//console.log("Table style =---->",this.widgetbuildervarservice.tableStyle)
// console.log("BG COLOR =---->",this._data.style?.table_body["background-color"])
    }

  creatDateRangeValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
      const err = {}
      const start = this.timeZoneService.setcurrentuserTime(form.get("fromDate").value);
      const end = this.timeZoneService.setcurrentuserTime(form.get("toDate").value);

      if (start && end) {
        const validyear = start.year() > 2000 && end.year() > 2000;
        if (!validyear) {
          err['yearrange'] = true;
        }
        const isRangeValid = (end.unix() - start.unix() >=0) && (end || start) < this.timeZoneService.getcurrentuserTime();

        if (!isRangeValid) {
          err['dateRange'] = true;
        }
      }
      return err;
    }
  }

  getFormattedValue(input: string, chart_type?: string): string {
    const num = Number(input);
  
    // handle invalid numbers
    if (isNaN(num)) {
      return input;
    }
  
    const formatter = this.dashboardService.getFormaterFunction(chart_type);
    return formatter(num);
  }

  getFormattedSize(input: string): string {
    const num = Number(input);
  
    // handle invalid or negative values
    if (isNaN(num) || num < 0) {
      return input;
    }
  
    const formatter = this.dashboardService.getFormaterSize();
    return formatter(num);
  }

  openOverlay_moreoptions_click(template, origin): void {
    let config = {
      data: {

        "template": template,
      }
    }
    this.dialogRef = this.cdkOverlyayService.dashboard_moreoptions(config, TemplateDropdownComponent, origin);
  }

  buildWidgetReqobj(datefilter,timerange){
    return {
      "widgetlist":[{
        "widget_id":this.widgetId,
        "platform_id":this.widgetInfo["platform_id"]
      }],
      "time_range":timerange,
      "timezone":this.sharedService.timeZone,
      "date_filter":datefilter,
      "mode":this.dashboardBuilderVarService.dashboard_preview_mode
    }
    
  }

  getWidgetData(datefilter,timerange){
    this.isProgress = true;
    this.handledashboardwidgetnodata.resetError()
    this.errorhandledashboardwidget.resetError()
    this.dashboardBuilderService.dashboardWidgetDataGet(this.buildWidgetReqobj(datefilter,timerange))
      .pipe(takeUntil(this.destroy$))
      .subscribe((dat:any)=>{
        if(dat.hasOwnProperty("isError") && dat["isError"]){
          this.errorhandledashboardwidget.seterror(true, dat.error?.errmsg);
          this.isProgress = false
          this.cdf.detectChanges() 
        } else {
          if(!dat[parseInt(this.widgetId)]["widgetdata"]?.rows?.length){
            this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
            this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            this.isProgress = false
            this.cdf.detectChanges() 
          } else {
            this.tableData = dat[parseInt(this.widgetId)]["widgetdata"]
            this.tableData = this.formatWidgetData(this.tableData)
            this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            this.isProgress = false
            this.cdf.detectChanges()   
          } 
        }
        
      })
  }

  refreshWidget(){
    if(this.dialogRef){
      this.dialogRef.close()
    }
    this.resetdateinput()
    this.setTimeRange(this.widgetInfo.time_range)
    this.filterDays = this.widgetInfo.time_range[2]
    this.getWidgetData(false,this.sharedService.getTimerangeFromMetaDate(this.widgetInfo.time_range))    
  }

  formatWidgetData(widgetData: any) {
    if (!widgetData?.rows || !widgetData?.headers) {
      return widgetData;
    }
  
    // find all headers where disp === "Time"
    const timeHeaders = widgetData.headers
      .filter((h: any) => h.disp?.toLowerCase() === 'time')
      .map((h: any) => h.value);
  
    const formattedRows = widgetData.rows.map((row: any) => {
      const updatedRow = { ...row };
  
      timeHeaders.forEach((key: string) => {
        const value = updatedRow[key];
  
        // skip null/undefined
        if (value === null || value === undefined) return;
  
        const strValue = String(value);
  
        // if value is like 00,01,02... convert to AM/PM
        const isHourFormat = /^\d{2}$/.test(strValue);
  
        if (isHourFormat) {
          const hour = Number(strValue);
  
          if (!isNaN(hour) && hour >= 0 && hour <= 23) {
            const formattedHour = hour % 12 || 12;
            const suffix = hour < 12 ? 'AM' : 'PM';
  
            updatedRow[key] = `${formattedHour}${suffix}`;
          }
        } else {
          // treat as epoch
          const epoch = Number(value);
  
          if (!isNaN(epoch)) {
            const date = new Date(
              strValue.length === 10 ? epoch * 1000 : epoch
            );
  
            updatedRow[key] = date.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short'
            });
          }
        }
      });
  
      return updatedRow;
    });
  
    return {
      ...widgetData,
      rows: formattedRows
    };
  }

  dateFilterClick(){
    if(!this.selectTime.errors){
    if(this.previewRef){
      this.previewRef.close()
      this.dialogRef.close()
    }
    this.setTimeRange("")
    let time_range = [this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.fromDate.value).format(this.dashboardService.timeformat), this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat)]
    this.getWidgetData(true,time_range)
  }
}

  relativeTimeClick(mode:string,filtervalue:any,timemode:string) {
    if (this.previewRef) {
      this.previewRef.close()
      this.dialogRef.close()
    }
//console.log("filtervalue===",filtervalue)
    this.setTimeRange(filtervalue)
    let timerange = this.sharedService.getTimerangeFromMetaDate(filtervalue)
    this.getWidgetData(true,timerange)
  }

  download_click(){
    if (!this.handledashboardwidgetnodata.status) {
      // this.moreOptionState = false; //close the moreoption div before downloading
      this.cdf.detectChanges(); // it stop executing the next lines untill the change is ddtected
      let date="DATE : "+this.timeZoneService.getcurrentuserTime().format("DD-MM-YYYY")+"\n"+"TIME : "+this.timeZoneService.getcurrentuserTime().format("hh:mm:ss")
      const fileName = this.title+"_"+this.timeZoneService.getcurrentuserTime().format("DDMMYYYY")+".pdf"

      const PDF = new jsPDF('portrait', 'px', 'a4') as jsPDFWithPlugin;
      PDF.addFileToVFS('Metropolis-ExtraLight.ttf', Metropolis_ExtraLight);
      PDF.addFileToVFS('Metropolis-Light.ttf', Metropolis_Light);
      PDF.addFileToVFS('Metropolis-LightItalic.ttf', Metropolis_LightItalic);
      PDF.addFileToVFS('Metropolis-Medium.ttf', Metropolis_Medium);
      PDF.addFileToVFS('Metropolis-Regular.ttf', Metropolis_Regular);
      PDF.addFileToVFS('Metropolis-SemiBold.ttf', Metropolis_SemiBold);
      PDF.addFont('Metropolis-Regular.ttf', 'metropolis', 'normal');
      PDF.addFont('Metropolis-Light.ttf', 'metropolis', 'light');
      PDF.addFont('Metropolis-SemiBold.ttf', 'metropolis', 'bold');
      PDF.setFontSize(15)
      PDF.setTextColor('#0A4143')
      PDF.setFont('metropolis','normal')
      PDF.text(this.title,26,20)
      PDF.setFontSize(9)
      PDF.setTextColor('#0A4143')
      PDF.setFont('metropolis','light')
      // PDF.text(this.widgetDetail.timeRange[0]+' - '+this.widgetDetail.timeRange[1],6,25)
      PDF.text(this.subtitle,26,30)
      PDF.setFontSize(9)
      PDF.setTextColor('#0A4143')
      PDF.setFont('metropolis','normal')
      PDF.text(date,350,20)
      let position = 50;

      // PDF.autoTable({
      //   startY:position,
      //   theme: 'plain',
      //   headStyles: { fillColor: '#E8E8E8' },
      //   head: [this.widgetDetail.tableHeaders],
      //   body: this.widgetDetail.tableRows.map(Object.values)
      // });

      PDF.autoTable({
        head: [this.tableData.headers.map((obj)=>obj.disp)],
        body: this.tableData.rows.map(row=>
          this.tableData.headers.map(col => row[col.value])
        ),
        startY:position,
        
        headStyles: {
          font: 'metropolis',
          // fillColor: "white",
          fillColor:"#f1f6f8",
          fontSize: 12,
          // textColor: "#0A4143"
          textColor:"#48454a",
          minCellWidth:10
        },
        styles: {
          font: 'metropolis',
          // cellPadding:2,
          fontSize: 10,
          cellWidth: "auto",
          // textColor: "gray",
          textColor:"#48454a",
          cellPadding:{
            "top":3,
            "bottom":3
          }
          
          // lineWidth: 1
          // lineWidth: 0.2,
          // lineColor: [0, 0, 0]
        },
        
        alternateRowStyles: {
          fillColor: "white"
        },
        didDrawCell(data) {
          const { cell, row, table } = data;
      
          // if (data.section === 'body') {
            const x = cell.x;
            const y = cell.y + cell.height;
            const width = cell.width;
      
            PDF.setLineWidth(1);
            PDF.line(x, y, x + width, y);
          // }
        },
        
        // tableLineWidth: 0.2,
        // tableLineColor: [0, 0, 0]
      });
      PDF.save(fileName);
    }
  }
  

  closeOptions_click() {
    if (this.dialogRef) {
      this.dialogRef.close()
    }
  }

  open_overlay(template:any, origin:any,){
    let config = {
      // width: '5%',
      // backdropClass: 'cdk-overlay-dark-backdrop',
      data: {

        "template": template,
      }
    }
    this.previewRef = this.cdkOverlyayService.openPreview(config, TemplateDropdownComponent, origin);

  
    this.previewRef.$closed.subscribe(() => {
      
    })
  }

  openOverlay_templateRef(template:any, origin:any, overlaytype:any):void {
    this.open_overlay(template,origin)
  }

  fullscreen_click(header,subheader,body): void {
      // subTitle = ''
      if (!this.handledashboardwidgetnodata.status) {
        this.matDialog.open(DialogBoxComponent, {
          width: '60%',
          height: '80vh',
          data: {
            template: body,
            head: header,
            subHead: subheader,
          }
        });
      }
    }

    resetdateinput() {
      this.selectTime.controls.fromDate.reset(this.defaultTimeRange.from);
      this.selectTime.controls.toDate.reset(this.defaultTimeRange.to);
  }
  
  
  setTimeRange(noOfDays: any) {
    if (noOfDays && noOfDays[2] >= 0) {
      this.filterDays = noOfDays[2];
      this.timeRange.controls.fromDate.patchValue(this.sharedService.calculate_timerange(noOfDays)[0]);
      this.timeRange.controls.toDate.patchValue(this.sharedService.calculate_timerange(noOfDays)[1]);
    } else {
      this.filterDays = undefined;
      this.timeRange.controls.fromDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.fromDate.value).format('YYYY-MM-DD'));
      this.timeRange.controls.toDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.toDate.value).format('YYYY-MM-DD'));
    }
  }
  
  
  customSubtitle(fromdate, todate, numDays) {
    let sub = ""
    let format = 'D MMM'
    switch (true) {
      case (numDays == undefined || (fromdate && todate)):
        this.subtitle = sub + ` ` + `custom   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      case (numDays == 1):
        this.subtitle = sub + ` ` + ` yesterday` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      case (numDays == 0):
        this.subtitle = sub + ` ` + ` today` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      default:
        this.subtitle = sub + ` ` + ` past ${numDays + 1} days` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
    }
  }

  checkmetric(field){
    if(field?.startsWith('metric')){
      return true
    }else{
      false
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  

}
